import { client } from "./client";

export const fetchAwards = async () => {
    const response = await client.get("/api/awards/");
    return response.data;
};
